import React, { useState, useCallback, useEffect, useRef } from "react";
import PasswordPolicy from "../SecuritySettings/PasswordPolicy";
import MailDomains from "../SecuritySettings/MailDomains";
import AccountActivityPolicy from "../SecuritySettings/AccountActivityPolicy";
import { useNavigate, useLocation } from "react-router-dom";
import { SECURITY_SETTINGS_TYPE } from "constants/common";
import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import { BsArrowRight } from "react-icons/bs";
import { APP_ROUTES } from "constants/AppRoutes";
import { useAppSelector } from "redux/hooks";

interface Props {}
export const Securitysettings: React.FC<Props> = () => {
  const isSSOEnabled = useAppSelector((state) => state.authConfig.isSSOEnabled);

  const ALL_SETTINGS_LIST = [
    { name: "Password Policy", code: "PA", selected: false },
    { name: "Account Activity Policy", code: "AC", selected: false },
    { name: "Mail Domains", code: "MA", selected: false },
  ];

  const SSO_SETTINGS_LIST = [
    { name: "Account Activity Policy", code: "AC", selected: false },
    { name: "Mail Domains", code: "MA", selected: false },
  ];

  const NON_SSO_SETTINGS_LIST = [
    { name: "Password Policy", code: "PA", selected: false },
    { name: "Mail Domains", code: "MA", selected: false },
  ];

  const SECURITYSETTINGS_LIST = isSSOEnabled ? SSO_SETTINGS_LIST : NON_SSO_SETTINGS_LIST;
  const defaultTab = isSSOEnabled
    ? SECURITY_SETTINGS_TYPE.ACCOUNT_ACTIVITY_POLICY
    : SECURITY_SETTINGS_TYPE.PASSWORD_POLICY;

  const [showPasswordPolicy, setShowPasswordPolicy] = useState(false);
  const [showMailDomains, setShowMailDomains] = useState(false);
  const [showAccountActivityPolicy, setShowAccountActivityPolicy] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>();
  const showSubtitle = useRef(defaultTab);
  const navigate = useNavigate();

  const [securitysettingList, setsecuritysettingList] = useState<Array<any>>(
    SECURITYSETTINGS_LIST
  );

  const { state } = useLocation() as any;
  const from = state?.from || defaultTab;

  const handleRoleSelect = useCallback(
    (selectedItem) => {
      setSelectedItem(selectedItem.name);
      showSubtitle.current = selectedItem.name;
      const modifiedsiteList = securitysettingList.map((item) => {
        if (item.code === selectedItem.code) {
          item["selected"] = !item["selected"];
        } else {
          item["selected"] = false;
        }
        return item;
      });
      setsecuritysettingList(modifiedsiteList);

      navigate(`/${APP_ROUTES.SECURITY_SETTINGS}`, {
        state: {
          from: selectedItem.name,
        },
      });
    },
    [securitysettingList]
  );

  useEffect(() => {
    const list = isSSOEnabled ? SSO_SETTINGS_LIST : NON_SSO_SETTINGS_LIST;
    let resolvedTab = from;
    if (isSSOEnabled && from === SECURITY_SETTINGS_TYPE.PASSWORD_POLICY) {
      resolvedTab = SECURITY_SETTINGS_TYPE.ACCOUNT_ACTIVITY_POLICY;
    } else if (!isSSOEnabled && from === SECURITY_SETTINGS_TYPE.ACCOUNT_ACTIVITY_POLICY) {
      resolvedTab = SECURITY_SETTINGS_TYPE.PASSWORD_POLICY;
    }
    const selectedTab = list.find((item: any) => item.name === resolvedTab);
    if (selectedTab) {
      selectedTab.selected = true;
    }
    setsecuritysettingList([...list]);

    switch (resolvedTab) {
      case SECURITY_SETTINGS_TYPE.MAIL_DOMAINS:
        setSelectedItem("Mail Domains");
        showSubtitle.current = "Mail Domains";
        break;
      case SECURITY_SETTINGS_TYPE.ACCOUNT_ACTIVITY_POLICY:
        setSelectedItem("Account Activity Policy");
        showSubtitle.current = "Account Activity Policy";
        break;
      case SECURITY_SETTINGS_TYPE.PASSWORD_POLICY:
        setSelectedItem("Password Policy");
        showSubtitle.current = "Password Policy";
        break;
      default:
        setSelectedItem(defaultTab);
        showSubtitle.current = defaultTab;
    }
  }, [from, isSSOEnabled]);

  useEffect(() => {
    switch (selectedItem) {
      case "Password Policy":
        setShowPasswordPolicy(true);
        setShowMailDomains(false);
        setShowAccountActivityPolicy(false);
        break;
      case "Account Activity Policy":
        setShowPasswordPolicy(false);
        setShowMailDomains(false);
        setShowAccountActivityPolicy(true);
        break;
      case "Mail Domains":
        setShowPasswordPolicy(false);
        setShowMailDomains(true);
        setShowAccountActivityPolicy(false);
        break;
      default:
        break;
    }
  }, [selectedItem]);

  return (
    <div className="security-settings">
      <section className="d-flex align-items-center">
        <Breadcrumb
          title="Security Settings"
          classNames="organization-header"
          handleGoBackClick={() => navigate(`/${APP_ROUTES.MANAGE_VIEW}`)}
        />
        <div className="breadcrumb-right-arrow ml-3 mr-3">
          <BsArrowRight className="icon" />
        </div>
        <div className="breadcrumb-sub-page-title">
          <span>{showSubtitle.current}</span>
        </div>
      </section>

      <div className="securitysettings-container  d-flex">
        <section className="securitysettings-leftsidebar d-flex flex-column">
          <div className="securitysettings-listname">
            <div className="main">
              <ul className="list-items">
                {securitysettingList.map((item) => (
                  <li
                    key={item.code}
                    className={item.selected ? "active" : ""}
                    onClick={() => handleRoleSelect(item)}
                  >
                    {item.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
        <section className="securitysettings-expanded pl-3 pt-3 pr-3">
          {showPasswordPolicy && <PasswordPolicy />}
          {showAccountActivityPolicy && <AccountActivityPolicy />}
          {showMailDomains && <MailDomains />}
        </section>
      </div>
    </div>
  );
};
export default Securitysettings;
